/**
 * @description Hook utilizado para manipular análises cadavéricas de local
 * @author Diego Sabino Amorim de Araújo
 * @file useAnaliseCadavericaLocal.js
 * @license Copyright (c) 2022 SIGEP DIGETI ITEP/RN
 */

import { useFetch } from './useFetch'

export const useAnaliseCadavericaLocal = () => {
  const fetch = useFetch()

  const cadastrarAnaliseCadavericaLocal = async (
    values,
    setIdAnaliseCadavericaCadastrada,
    setProcessando
  ) => {
    if (setProcessando) setProcessando(true)
    const dados = {
      ...values,
      id_exame_local: values.idExameLocal,
      id_cadaver: values.idCadaver,
    }
    const response = await fetch.post(`analiseCadavericaLocal/`, dados)
    setIdAnaliseCadavericaCadastrada(response.data.analiseCadavericaLocal.id)
    if (setProcessando) setProcessando(false)
  }

  const getAnaliseCadavericaLocal = async (id, setAnaliseCadavericaLocal, setProcessando) => {
    if (setProcessando) setProcessando(true)
    const response = await fetch.get(`analiseCadavericaLocal/${id}`)
    setAnaliseCadavericaLocal(response.data.analiseCadavericaLocal)
    if (setProcessando) setProcessando(false)
  }

  const editarAnaliseCadavericaLocal = async (id, dados, setProcessando) => {
    if (setProcessando) setProcessando(true)
    const response = await fetch.put(`analiseCadavericaLocal/${id}`, dados)
    if (setProcessando) setProcessando(false)
    return response
  }

  const listarAnaliseCadavericaLocalDeExame = async (
    idCadaver,
    idExameRealizado,
    setProcessando
  ) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(
        `analiseCadavericaLocal/deExame/${idCadaver}/${idExameRealizado}`
      )
      return response.data.analiseCadaverica
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const setarAnaliseCadavericaLocalDeExameRealizado = async (
    idCadaver,
    idExameRealizado,
    values,
    setProcessando
  ) => {
    try {
      if (setProcessando) setProcessando(true)
      const dados = {
        ...values,
      }
      const response = await fetch.postOpenWithoutFeedback(
        `analiseCadavericaLocal/setar/deExame/${idCadaver}/${idExameRealizado}`,
        dados
      )
      return response.data.analiseCadaverica
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }
  return {
    cadastrarAnaliseCadavericaLocal,
    getAnaliseCadavericaLocal,
    editarAnaliseCadavericaLocal,
    listarAnaliseCadavericaLocalDeExame,
    setarAnaliseCadavericaLocalDeExameRealizado,
  }
}
